"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../types");
exports.isPolicyAllowsBsi = function (policyDetails) {
    return !policyDetails ||
        !policyDetails.policy ||
        (policyDetails.policy[types_1.ConsentPolicyCategories.Analytics] !== false &&
            policyDetails.policy[types_1.ConsentPolicyCategories.Functional] !== false);
};
//# sourceMappingURL=policy.js.map